import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {onMounted, ref, watch} from "vue";
import {AbstractStoreManagerBuilder} from "@/lib/store/manager/abstract/AbstractStoreManager";
import {WatchStopHandle} from "@vue/runtime-core";


export default /*#__PURE__*/_defineComponent({
  name: 'ConnectionLine',
  props: {
  fromElementId: {
    type: String,
    required: true,
  },
  toElementId: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    required: true,
  },
  forceRedraw: Number,
},
  setup(__props) {

const props = __props




let doElementsExist: boolean = false;

const from = ref();
const to = ref();
const lineSvg = ref();
const lineIndex = AbstractStoreManagerBuilder.createInstanceId();
const unwatchers: WatchStopHandle[] = [];

    onMounted(() =>
{
  init();

  tryDraw();

  watch(() => props.forceRedraw, () => {
    init();
    tryDraw();
  })
})

class Vector2D{

  public x: number;
  public y: number;

  constructor(x: number,y: number){
    this.x = x;
    this.y = y;
  }
}

const init = () =>
{
  from.value = document.getElementById(props.fromElementId);
  to.value = document.getElementById(props.toElementId);

  if (from.value && to.value)
  {
    doElementsExist = true;

    if (unwatchers.length === 0)
    {
      unwatchers.push(watch(() => from.value.style, () => {
        tryDraw();
      }))

      unwatchers.push(watch(() => to.value.style, () => {
        tryDraw();
      }))
    }
  }
  else
  {
    doElementsExist = false;

    lineSvg.value.innerHTML = "";
    isLineReset = true;

    unwatchers.map(unwatcher => unwatcher())
  }

}

const tryDraw = () =>
{
  if (doElementsExist)
  {
    /*Calculate position relative to div -- Done by https://stackoverflow.com/questions/3234256/find-mouse-position-relative-to-element */
    const rect = lineSvg.value.getBoundingClientRect();
    const fromRect = from.value.getBoundingClientRect();
    const toRect = to.value.getBoundingClientRect();

    //Store the mouse position as the "final" position
    const initialPosOfLine = new Vector2D(fromRect.left + 5 - rect.left, fromRect.top + 5 - rect.top);
    const finalPosOfLine = new Vector2D(toRect.left + 5 - rect.left, toRect.top + 5 - rect.top);
    //Draw a line from the initialPos to the current Mouse pos.
    drawToPos(initialPosOfLine, finalPosOfLine, 'line-'+lineIndex);
  }
}

let isLineReset: boolean = true;
let line: SVGLineElement;

//Draw a line between 2 points, if move its true, it will move the line instead of making it
const drawToPos = (initial: Vector2D, final: Vector2D, id: string) =>
{
  let move: boolean = !!line && !isLineReset;

  //If we are moving an existing line, set "line" to the current line, else, give to the new line the id attribute.
  if(!move) {
    //Declare a new Line in SVG
    line = document.createElementNS('http://www.w3.org/2000/svg','line');
    line.setAttribute('id',id)
  }

  //Define its starting position
  line.setAttribute('x1', '' + initial.x);
  line.setAttribute('y1', '' + initial.y);

  //Define its final position
  line.setAttribute('x2','' + final.x);
  line.setAttribute('y2','' + final.y);

  //Define its stroke.
  line.setAttribute("stroke", props.color)
  line.setAttribute("stroke-width", '2')

  //Append the line to the SVG canvas
  lineSvg.value.append(line);

  isLineReset = false;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: "line-svg",
    ref_key: "lineSvg",
    ref: lineSvg
  }, null, 512))
}
}

})